export default {
  targetId: "initial",
  mainContent: [],
  searchResults: {
    "errorMessage": "",
    "data": []
  },
  textSearchValue: "",
  textSearchStaticValue: "",
  warnings: {
    textSearchValueLength : false
  },
  dataContent: {
    "sidebar": [],
    rootItem: {},
    settings: {
      hideThemeWordsWithNomatches: true,
      showContentInFullHeight: true,
      showContentWindowInFullWidth: false,
      accordionActivationLevel: 1,
    },
    filters: {
      themeWords: false,
      textSearch: false
    },
    themeWords: {},
    mainContentHasItemsWithActiveThemeWords: null,
    currentItemLocationData: [],
    visibleContentId: 0,
    hash: ""
  },
  portletId: "",
  containerId: "",
  time: "123",
  initialLoad: true,
  tukaReady: false,
  scrollingReserved:  false,
  headersWithoutOrderNum: []
};

const sidebar_modern = {
  "sidebar" : [ {
    "name" : "LUKIJALLE",
    "description" : "Tulevaisuuskatsauksien tavoitteena on tuottaa yhteiskunnalliseen keskusteluun ja hallitusneuvottelujen pohjaksi tilanne- ja kehitysarvioita yhteiskunnan tilasta ja poliittista päätöksentekoa edellyttä...",
    "contentId" : 102366039,
    "themeWordsActive" : false,
    "childItemsActive" : false,
    "directChildItemsActive" : false,
    "themeWords" : {
      "Ilmastonmuutos" : false
    },
    "items" : [ {
      "name" : "Ympäristöministeriön toimintaympäristö muutoksessa",
      "description" : "Kaikki valtioneuvoston muutostekijät ovat tärkeitä ympäristöministeriön kannalta (http://vnk.fi/tulevaisuustyo/muutostekijakortit). Alla on kiteytetty ne, joiden arvioidaan eniten muuttavan ympäristöm...",
      "contentId" : 102366062,
      "themeWordsActive" : false,
      "childItemsActive" : false,
      "directChildItemsActive" : false,
      "themeWords" : {
        "Ilmastonmuutos" : false
      },
      "items" : [ ]
    }, {
      "name" : "Ympäristöministeriön tulevaisuuden teemat",
      "description" : "Ympäristöministeriön keskeisiä tulevaisuuden haasteita tarkastellaan kolmen teeman avulla: ’Hyvä ympäristö ja monimuotoinen luonto’, ’hiilineutraali kiertotalousyhteiskunta’ ja ’kestävä kaupunkikehity...",
      "contentId" : 102366080,
      "themeWordsActive" : false,
      "childItemsActive" : false,
      "directChildItemsActive" : false,
      "themeWords" : {
        "Ilmastonmuutos" : false,
        "Talous" : false
      },
      "items" : [ {
        "name" : "Hyvä ympäristö ja monimuotoinen luonto",
        "description" : "Kestävän kehityksen skenaarion mukainen tavoiteltu tulevaisuus 2030 Itämeren ja vesien hyvä tila on saavutettu. Itämeren sekä pinta- ja pohjavesien tila on hyvä ja vesien tilaa uhkaavat paineet ja ris...",
        "contentId" : 102366103,
        "themeWordsActive" : false,
        "childItemsActive" : false,
        "directChildItemsActive" : false,
        "themeWords" : {
          "Talous" : false
        },
        "items" : [
			{
        "name" : "Alaotsikko 2.1.1",
        "description" : "Alaotsikko 2.1.1 description",
        "contentId" : 102422226,
        "themeWordsActive" : false,
        "childItemsActive" : false,
        "directChildItemsActive" : false,
        "themeWords" : { 
          "Ilmastonmuutos" : false
        }, 
		    "items" : [ ]
		},
		{
        "name" : "Alaotsikko 2.1.2",
        "description" : "Alaotsikko 2.1.2 description",
        "contentId" : 102422248,
        "themeWordsActive" : false,
        "childItemsActive" : false,
        "directChildItemsActive" : false,
        "themeWords" : { 
          "Eriarvoisuus": false
        },
		    "items" : [ ]
		},
		{
        "name" : "Alaotsikko 2.1.3",
        "description" : "Alaotsikko 2.1.3 description",
        "contentId" : 102422292,
        "themeWordsActive" : false,
        "childItemsActive" : false,
        "directChildItemsActive" : false,
        "themeWords" : { 
          "Talous" : false,
          "Ilmastonmuutos" : false
        },
		"items" : [ ]
		}
		]
      }, {
        "name" : "Hiilineutraali kiertotalousyhteiskunta",
        "description" : "Kestävän kehityksen skenaarion mukainen tavoiteltu tulevaisuus 2030 Suomi on vähentänyt kasvihuonekaasupäästöjä merkittävästi. Suomi on aktiivinen ja vahva toimija kansainvälisessä ilmastopolitiikassa...",
        "contentId" : 102366122,
        "themeWordsActive" : false,
        "childItemsActive" : false,
        "directChildItemsActive" : false,
        "themeWords" : {
          "Talous" : false,
          "Liikenne" : false
        },
        "items" : [ ]
      }, {
        "name" : "Kestävä kaupunkikehitys",
        "description" : "Kestävän kehityksen skenaarion mukainen tavoiteltu tulevaisuus 2030 Kaupunkiseudut lisäävät alueiden kestävää kasvua. Maankäyttö- ja asuntopolitiikalla edistetään kaupunkiseutujen elinvoimaa, kestävää...",
        "contentId" : 102366141,
        "themeWordsActive" : false,
        "childItemsActive" : false,
        "directChildItemsActive" : false,
        "themeWords" : { 
          "Liikenne" : false
        },
        "items" : [ ]
      } ]
    }, {
      "name" : "Kestävän muutoksen mahdollistajat",
      "description" : "Muutoksen mahdollistajina jokaisessa teemassa voidaan tunnistaa tarvetta uudenlaisille toimintatavoille, entistä vahvemmille kumppanuuksille ympäristö- ja tutkimustiedon hyödyntämiselle sekä kansainvä...",
      "contentId" : 102366158,
      "themeWordsActive" : false,
      "childItemsActive" : false,
      "directChildItemsActive" : false,
      "themeWords" : {
        "Hyvinvointiyhteiskunta" : false
       },
      "items" : [ ]
    } ]
  } ]
}

const sidebar_old = {
  sidebar: {
    name: "0. XXXXXXX - ministeriöiden yhteinen tulevaisuuskatsaus 2022",
    description: "jos tarvitaan, kuvaus siitä, mitä tähän liittyy.",
    img: "http://localhost:5050/images/70-luku_rakennustekniikka.png",
    contentId: 101827366,
    themeWordsActive: false,
    childItemsActive: false,
    directChildItemsActive: false,
    currentItem: false,
    themeWords: {
      "eriarvoisuus" : false, 
      "talous" : false
    },
    items: [
      {
        name: "1. Kestävyystarkastelu keskiöön” - johdanto (myös koronasta)",
        description: "",
        img: "",
        contentId: 101827382,
        themeWordsActive: false,
        childItemsActive: false,
        directChildItemsActive: false,
        currentItem: false,
        themeWords: {
          "hyvinvointiyhteiskunta" : false, 
          "talous" : false
        },
        items: [],
      },
      {
        name: "2. Miltä nyt näyttää?” - toimintaympäristökuvaus (keskeneräisiä työotsikoita)",
        description: "",
        img: "",
        contentId: 101827400,
        themeWordsActive: false,
        childItemsActive: false,
        directChildItemsActive: false,
        currentItem: false,
        themeWords: {
          "eriarvoisuus" : false, 
          "talous" : false
        },
        items: [
          {
            name: "2.1. Miten on mahdollista vastata hyvinvointiyhteiskunnan arvolupaukseen tulevaisuudessa? Tulevaisuuden hyvinvointiyhteiskunta - Yhteiskunnallinen",
            description: "",
            img: "",
            contentId: 101827400,
            themeWordsActive: false,
            childItemsActive: false,
            directChildItemsActive: false,
            currentItem: false,
            themeWords: {
              "eriarvoisuus" : false, 
              "talous" : false
            },
            items: [
              {
                name: "2.1.1. Väestönkehityksen ja (kansainvälisen) liikkuvuuden vaikutukset",
                description: "",
                img: "",
                contentId: 101827400,
                themeWordsActive: false,
                childItemsActive: false,
                directChildItemsActive: false,
                currentItem: false,
                themeWords: {
                  "eriarvoisuus" : false, 
                },
                items: []
              },
              {
                name: "2.1.2.	Osaaminen ja sivistys kriittisinä tekijöinä / osaamisen ja sivistyksen merkitys korostuu",
                description: "",
                img: "",
                contentId: 101827400,
                themeWordsActive: false,
                childItemsActive: false,
                directChildItemsActive: false,
                currentItem: false,
                themeWords: {
                  "eriarvoisuus" : false, 
                  "tutkimus" : false
                },
                items: []
              },
            ]
          },
          {
            name: "2.2. Neljäs teollinen vallankumous haastaa kaiken - Teknologinen",
            description: "",
            img: "",
            contentId: 101827400,
            themeWordsActive: false,
            childItemsActive: false,
            directChildItemsActive: false,
            currentItem: false,
            themeWords: {
              "talous" : false
            },
            items: [
              {
                name: "2.2.1. Laadukas tutkimus, kehittäminen, innovaatiot ja kyvykkyydet tulevaisuuden ratkaisijana",
                description: "",
                img: "",
                contentId: 101827400,
                themeWordsActive: false,
                childItemsActive: false,
                directChildItemsActive: false,
                currentItem: false,
                themeWords: { 
                  "talous" : false
                },
                items: []
              },
              {
                name: "2.2.2.	Kestävää kasvua luova toimintaympäristö toimintatavoilla, rakenteilla ja sääntelyllä",
                description: "",
                img: "",
                contentId: 101827400,
                themeWordsActive: false,
                childItemsActive: false,
                directChildItemsActive: false,
                currentItem: false,
                themeWords: {
                  "eriarvoisuus" : false, 
                  "talous" : false
                },			  
                items: []
              },
            ]
          },
        ],
      },
      {
        name: "3. Mitä voimme tehdä - ratkaisujen suunnat” - ministeriökohtaiset tulevaisuuskatsaukset (vuoden 2018 ratkaisut)",
        description: "",
        img: "",
        contentId: 101827451,
        themeWordsActive: false,
        childItemsActive: false,
        directChildItemsActive: false,
        currentItem: false,
        themeWords: {
          "talous" : false
        },	
        items: [
          {
            name: "3.1. KANSALLISEN UUDISTUMISKYVYN EDELLYTYKSET - VNK",
            description: "",
            img: "",
            contentId: 101827468,
            themeWordsActive: false,
            childItemsActive: false,
            directChildItemsActive: false,
            currentItem: false,
            themeWords: {
              "talous" : false, 
              "hyvinvointiyhteiskunta" : false, 
              "eriarvoisuus" : false, 
              "ilmastonmuutos" : false, 
              "tutkimus" : false
            },
            items: []
          },
        ]
      }
    ],
  },
}

const mainContent_old = {
  mainContent: [{
    header: "Tämä kohta korvaantuu toisella datalla",
    content: "Content-osassa oleva sisältö",
    themeWords: {
      "eriarvoisuus" : false, 
      "talous" : false
    },
  },
  {
    header: "Toinen, testiksi lisätty data",
    content: "Content-osassa oleva sisältö",
    themeWords: {
      "tutkimus" : false, 
    },
  },
  {
    header: "Kolmas sisältökohde, otsikko",
    content: "Content-osassa oleva sisältö",
    themeWords: {
      "ilmastonmuutos" : false, 
      "talous" : false
    },
  }],
}
